import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { MediaBreakPointUp } from '@lean-body/components/styles';
export const ParticipationCount = (props) => {
    const formatCount = () => {
        return props.count.toLocaleString();
    };
    return (React.createElement("div", { className: css(styles.participation) },
        React.createElement("span", { className: css(styles.icon) },
            React.createElement("img", { src: "/assets/images/icons/outlined_person.svg", className: css(styles.outlinedPerson) })),
        React.createElement("span", { className: css(styles.count) }, formatCount())));
};
const styles = StyleSheet.create({
    participation: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 8,
    },
    icon: {
        display: 'inline-block',
        width: 16,
        height: 16,
        backgroundColor: '#65CED9',
        borderRadius: '50%',
        textAlign: 'center',
        [MediaBreakPointUp.LG]: {
            width: 32,
            height: 32,
            marginRight: '.5rem',
        },
    },
    outlinedPerson: {
        width: 8,
        height: 8,
        marginTop: -4,
        [MediaBreakPointUp.LG]: {
            width: 16,
            height: 16,
            marginTop: 8,
        },
    },
    count: {
        fontSize: 10,
        fontWeight: 'bold',
        color: '#6F6F7F',
        marginLeft: 4,
        [MediaBreakPointUp.LG]: {
            fontSize: '1rem',
        },
    },
});
